










































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { OpenAPI, MessageService } from '@/api'
import { UserClientJSON } from '@/apiv3/index'
import { FetchRPC } from 'twirp-ts/build/twirp/http.client'

type Headers = Record<string, string>

@Component
export default class Navbar extends Vue {
  count: number | null = null
  @Prop() client!: UserClientJSON

  mounted (): void {
    OpenAPI.BASE = 'https://prepodam.ru/api/v2'
    OpenAPI.HEADERS = this.getToken

    this.client = new UserClientJSON(FetchRPC({
      baseUrl: 'https://prepodam.ru/api',
      headers: {
        token: this.getHeaderToken()
      }
    }))

    MessageService.getMessagesUnread().then(resp => {
      this.count = resp.count
    })
  }

  authorized (): boolean {
    const token = this.$cookies.get('randomUserId')

    if (token === null || typeof token !== 'string') {
      return false
    }

    return true
  }

  getHeaderToken (): string {
    const token = this.$cookies.get('randomUserId')

    if (token === null || typeof token !== 'string') {
      return ''
    }

    return token
  }

  getToken (): Promise<Headers> {
    return new Promise(resolve => {
      const token = this.$cookies.get('randomUserId')

      if (token === null || typeof token !== 'string') {
        resolve({})
        return
      }

      resolve({ token })
    })
  }
}
